import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function WheelIndicatorIcon({ color, className }) {
    return (
        <svg
            width="67"
            height="26"
            viewBox="0 0 67 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <path
                id="FLECHE"
                d="M66.9461 6.12724C47.9128 -1.63236 19.0687 -1.5131 0.146729 6.48501L0.37729 7.18465C4.89312 6.71557 10.1801 6.15904 14.696 5.88873L33.6975 25.2321L53.2873 5.99208C57.5884 6.38961 62.1679 6.68377 66.477 7.31185L66.9381 6.12724H66.9461Z"
                fill={color}
            />
        </svg>
    );
}

WheelIndicatorIcon.propTypes = propTypes;
WheelIndicatorIcon.defaultProps = defaultProps;

export default WheelIndicatorIcon;
